/**
 * Local Imports
*/

import { CommandRegister } from '@system/Command';
import { TwitchConfig } from '@config/Twitch';
import { TwitchStart, TwitchWriteMessage } from '@system/Twitch';

/**
 * Relative Imports
*/

import { ChooseHandleToggle, ChoosedayHandleRoll, ChoosedayHandleRolls } from './Chooseday';

/**
 * Functions
*/

/**
 * @return {void}
 */
function ApplicationRegister(): void
{
    CommandRegister('rolls', ChoosedayHandleRolls);
    CommandRegister('roll', ChoosedayHandleRoll);
    CommandRegister('troll', ChoosedayHandleRoll);
    CommandRegister('d20', ChoosedayHandleRoll);
    CommandRegister('chance', ChoosedayHandleRoll);
    CommandRegister('chooseday', ChooseHandleToggle);
}

/**
 * @return {Promise<void>}
 */
async function ApplicationStart(): Promise<void>
{
    await TwitchStart(TwitchConfig.username, TwitchConfig.token, TwitchConfig.channel);
    TwitchWriteMessage(TwitchConfig.channel, 'Chooseday bot has been loaded.');
}

/**
 * Main
*/

ApplicationRegister();
ApplicationStart();
